import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = ["xlink:href", "height", "width"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_6 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 0,
  style: {"overflow-y":"auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_DocumentValidationSpeedRun = _resolveComponent("DocumentValidationSpeedRun")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_UploadDocument = _resolveComponent("UploadDocument")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-1",
    style: _normalizeStyle(_ctx.$vuetify.display.mobile ? 'width: 100vw;' : '')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: _normalizeClass(_ctx.inZTillReceipt.originalDocument ? '' : 'd-flex justify-center')
      }, {
        default: _withCtx(() => [
          (!_ctx.$vuetify.display.mobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "7",
                class: "pr-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "default_card_wm elevation-0 pt-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DocumentMenu, {
                        MenuOptions: _ctx.documentMenuOptions,
                        onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                        onZoomIn: _cache[1] || (_cache[1] = ($event: any) => (_ctx.zoomManager.zoomIn())),
                        onZoomOut: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomManager.zoomOut())),
                        onResetZoom: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomManager.resetZoom())),
                        onRotateLeft: _cache[4] || (_cache[4] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('left', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                        onRotateRight: _cache[5] || (_cache[5] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('right', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                        onDownload: _ctx.startDownloadFile,
                        onDisplayFile: _cache[6] || (_cache[6] = ($event: any) => (((_ctx.showAccountingLines = false), (_ctx.displayActivity = false)))),
                        onDisplayAccountingLine: _cache[7] || (_cache[7] = ($event: any) => (
                            ((_ctx.showAccountingLines = true), (_ctx.displayActivity = false))
                        )),
                        onUpload: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogUploadDocument = true)),
                        onActivity: _cache[9] || (_cache[9] = ($event: any) => (((_ctx.showAccountingLines = false), (_ctx.displayActivity = true)))),
                        onAnalyse: _cache[10] || (_cache[10] = ($event: any) => (_ctx.analyseDocumentDialog = true)),
                        onDelete: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteZTillDialog = true))
                      }, null, 8, ["MenuOptions", "onDownload"]),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          (_ctx.showAccountingLines)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_accounting_item_static, {
                                    companyId: _ctx.companyId,
                                    zTillReceiptId: _ctx.inZTillReceipt.id,
                                    mode: "Embedded",
                                    ref: "accountingItemStatic"
                                  }, null, 8, ["companyId", "zTillReceiptId"]),
                                  (_ctx.zTillHasChanged)
                                    ? (_openBlock(), _createBlock(_component_v_alert, {
                                        key: 0,
                                        type: "warning",
                                        class: "mt-2",
                                        absolute: "",
                                        "model-value": true
                                      }, {
                                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                                          _createTextVNode(" Le document a été modifié. Enregistrez les modifications pour actualiser les lignes comptables ")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : (_ctx.displayActivity)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "12",
                                  style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_UsersActivitiesHistory, {
                                      zTillReceiptId: _ctx.inZTillReceipt.id
                                    }, null, 8, ["zTillReceiptId"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (_ctx.isPDF)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "12",
                                        class: "d-flex justify-center",
                                        style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ossPdf, {
                                            rotation: _ctx.documentPdfRotation,
                                            documentId: _ctx.inZTillReceipt.originalDocument.id
                                          }, null, 8, ["rotation", "documentId"])
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: "12",
                                        style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_1, [
                                            (_ctx.inZTillReceipt && _ctx.inZTillReceipt.originalDocument)
                                              ? (_openBlock(), _createElementBlock("svg", {
                                                  key: 0,
                                                  id: "svg-zTillReceipt",
                                                  xmlns: "http://www.w3.org/2000/svg",
                                                  width: "100%",
                                                  viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                                  style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                                }, [
                                                  _createElementVNode("image", {
                                                    id: "svg-image-zTillReceipt",
                                                    "xlink:href": _ctx.inZTillReceipt.originalDocument.signedUrl,
                                                    x: "0",
                                                    y: "0",
                                                    height: `${_ctx.imageHeight}px`,
                                                    width: `${_ctx.imageWidth}px`
                                                  }, null, 8, _hoisted_3)
                                                ], 8, _hoisted_2))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                ], 64))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: _ctx.$vuetify.display.mobile ? 12 : 5,
            class: "my-0 pl-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important","height":"calc(100vh - 82px)","overflow-y":"auto"},
                class: "default_card_wm elevation-0 rounded-l-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            ripple: false,
                            class: "oss-list-item mb-2",
                            color: "success"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "3",
                                        class: "d-flex align-center",
                                        style: {"border-right":"1px #ededed solid"}
                                      }, {
                                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                                          _createElementVNode("b", null, "Statut", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "9",
                                        class: "d-flex align-center pl-2"
                                      }, {
                                        default: _withCtx(() => [
                                          (
                                                    _ctx.processAnalysis &&
                                                    !_ctx.inZTillReceipt.originalDocument.errorMessage
                                                )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " En attente d'analyse par le cabinet "))
                                            : (
                                                    _ctx.reUploadDocument &&
                                                    _ctx.inZTillReceipt.originalDocument.errorMessage
                                                )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Erreur : " + _toDisplayString(_ctx.inZTillReceipt.originalDocument.errorMessage), 1))
                                              : (
                                                    _ctx.reUploadDocumentClient &&
                                                    _ctx.inZTillReceipt.originalDocument.errorMessage
                                                )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Erreur de lecture du fichier : contacter votre cabinet "))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.ztillStatus), 1))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.toValidate || _ctx.validated || _ctx.forceForm)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!_ctx.processAnalysis)
                          ? (_openBlock(), _createBlock(_component_v_window, {
                              key: 0,
                              modelValue: _ctx.windowStep,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.windowStep) = $event)),
                              touchless: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_window_item, { step: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pt-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "pr-1"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.period === 'WE')
                                              ? (_openBlock(), _createBlock(_component_oss_date_picker, {
                                                  key: 0,
                                                  modelValue: _ctx.week,
                                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.week) = $event)),
                                                  "hide-details": true,
                                                  label: _ctx.$t('shared.date'),
                                                  mandatory: false,
                                                  textFieldReadOnly: false,
                                                  type: _ctx.month ? 'month' : 'date',
                                                  filterWithoutClosedAccountingPeriods: true
                                                }, null, 8, ["modelValue", "label", "type"]))
                                              : (_openBlock(), _createBlock(_component_oss_date_picker, {
                                                  key: 1,
                                                  modelValue: _ctx.date,
                                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.date) = $event)),
                                                  "hide-details": true,
                                                  label: _ctx.$t('shared.date'),
                                                  mandatory: false,
                                                  textFieldReadOnly: false,
                                                  type: _ctx.month ? 'month' : 'date',
                                                  filterWithoutClosedAccountingPeriods: true
                                                }, null, 8, ["modelValue", "label", "type"]))
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "6" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_select_filled, {
                                              modelValue: _ctx.period,
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.period) = $event)),
                                              items: _ctx.periods,
                                              label: "Période",
                                              "item-value": "key",
                                              "item-title": "value",
                                              density: "compact"
                                            }, null, 8, ["modelValue", "items"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            (_ctx.inZTillReceipt && _ctx.inZTillReceipt.document)
                                              ? (_openBlock(), _createBlock(_component_FreeTag, {
                                                  key: 0,
                                                  companyTags: _ctx.allCompanyTags,
                                                  company: _ctx.company,
                                                  document: _ctx.inZTillReceipt.document,
                                                  splitUserPartitions: true
                                                }, null, 8, ["companyTags", "company", "document"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-2 pt-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "d-flex align-center col-auto pr-3 title"
                                        }, {
                                          default: _withCtx(() => _cache[41] || (_cache[41] = [
                                            _createTextVNode(" Ventes ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_divider)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "1",
                                          class: "d-flex align-center col-auto pl-3 title"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_add_icon, {
                                              size: "x-small",
                                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addLine()))
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.incomes && _ctx.incomes.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incomes, (income, index) => {
                                            return (_openBlock(), _createBlock(_component_v_row, {
                                              "no-gutters": "",
                                              key: index
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "11" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "py-1"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "6",
                                                          class: "pr-1"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_select_filled, {
                                                              "hide-details": true,
                                                              modelValue: income.accountableAccount,
                                                              "onUpdate:modelValue": ($event: any) => ((income.accountableAccount) = $event),
                                                              items: _ctx.salesAccountableAccounts,
                                                              label: "Type de recette",
                                                              "item-value": "name",
                                                              "single-line": "",
                                                              density: "compact",
                                                              "item-title": (item) => item.description
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, { cols: "6" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_oss_text_field_filled, {
                                                              regular: "",
                                                              dense: "",
                                                              "hide-details": true,
                                                              label: "Dont offert",
                                                              outlined: "",
                                                              modelValue: income.freeAmount,
                                                              "onUpdate:modelValue": ($event: any) => ((income.freeAmount) = $event)
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, { class: "py-1 pr-1" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_oss_text_field_filled, {
                                                              regular: "",
                                                              dense: "",
                                                              "hide-details": true,
                                                              outlined: "",
                                                              label: "HT",
                                                              readonly: "",
                                                              disabled: "",
                                                              modelValue: income.netAmount,
                                                              "onUpdate:modelValue": ($event: any) => ((income.netAmount) = $event)
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, { class: "py-1 pr-1" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_oss_text_field_filled, {
                                                              label: "TVA",
                                                              regular: "",
                                                              dense: "",
                                                              "hide-details": true,
                                                              outlined: "",
                                                              readonly: "",
                                                              disabled: "",
                                                              modelValue: income.vatAmount,
                                                              "onUpdate:modelValue": ($event: any) => ((income.vatAmount) = $event)
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, { class: "py-1 pr-1" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_oss_text_field_filled, {
                                                              density: "compact",
                                                              "hide-details": true,
                                                              label: "TTC",
                                                              "onUpdate:modelValue": [($event: any) => (_ctx.TTCPrice(income)), ($event: any) => ((income.grossAmount) = $event)],
                                                              modelValue: income.grossAmount
                                                            }, null, 8, ["onUpdate:modelValue", "modelValue"])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, { class: "py-1 pr-1" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_select_filled, {
                                                              items: _ctx.vatRates,
                                                              "hide-details": true,
                                                              label: "Taux de TVA",
                                                              "onUpdate:modelValue": ($event: any) => (
                                                                _ctx.VATRate(income, $event)
                                                            ),
                                                              "model-value": 
                                                                income.vatType === 'INTRACOM'
                                                                    ? '0INTRACOM'
                                                                    : income.vatRate
                                                            ,
                                                              density: "compact"
                                                            }, null, 8, ["items", "onUpdate:modelValue", "model-value"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, { cols: "12" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_FreeTag, {
                                                              companyTags: _ctx.allCompanyTags,
                                                              document: income.document
                                                            }, null, 8, ["companyTags", "document"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, {
                                                  cols: "1",
                                                  class: "d-flex align-center justify-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.incomes.length > 1)
                                                      ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.deleteCategory(income))
                                                        }, null, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                (index < _ctx.incomes.length - 1)
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 0,
                                                      cols: "12"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_divider, { class: "my-2" })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128)),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, {
                                                    "no-gutters": "",
                                                    class: "py-2 pt-5"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
                                                        default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                          _createTextVNode(" Total ")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "9",
                                                        class: "d-flex align-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_divider)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { class: "pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_text_field_filled, {
                                                    regular: "",
                                                    dense: "",
                                                    "hide-details": true,
                                                    label: "HT",
                                                    outlined: "",
                                                    readonly: "",
                                                    "model-value": 
                                                        _ctx.newCommonFormatCurrency(
                                                            _ctx.totalNetAmount,
                                                            undefined,
                                                        )
                                                    
                                                  }, null, 8, ["model-value"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_text_field_filled, {
                                                    regular: "",
                                                    dense: "",
                                                    "hide-details": true,
                                                    label: "TVA",
                                                    outlined: "",
                                                    readonly: "",
                                                    "model-value": 
                                                        _ctx.newCommonFormatCurrency(
                                                            _ctx.totalVatAmount,
                                                            undefined,
                                                        )
                                                    
                                                  }, null, 8, ["model-value"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_text_field_filled, {
                                                    regular: "",
                                                    dense: "",
                                                    "hide-details": true,
                                                    label: "TTC",
                                                    outlined: "",
                                                    readonly: "",
                                                    "model-value": 
                                                        _ctx.newCommonFormatCurrency(
                                                            _ctx.totalGrossAmount,
                                                            undefined,
                                                        )
                                                    
                                                  }, null, 8, ["model-value"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "pr-1" }),
                                              _createVNode(_component_v_col, { cols: "1" })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, {
                                                    "no-gutters": "",
                                                    class: "py-2 pt-5"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
                                                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                                                          _createTextVNode(" Commission | Frais ")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "9",
                                                        class: "d-flex align-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_divider)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { class: "py-1 pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_text_field_filled, {
                                                    regular: "",
                                                    dense: "",
                                                    "hide-details": true,
                                                    outlined: "",
                                                    label: "HT",
                                                    readonly: "",
                                                    disabled: "",
                                                    modelValue: _ctx.commission.netAmount,
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.commission.netAmount) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "py-1 pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_text_field_filled, {
                                                    label: "TVA",
                                                    regular: "",
                                                    dense: "",
                                                    "hide-details": true,
                                                    outlined: "",
                                                    readonly: "",
                                                    disabled: "",
                                                    modelValue: _ctx.commission.vatAmount,
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.commission.vatAmount) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "py-1 pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_text_field_filled, {
                                                    density: "compact",
                                                    "hide-details": true,
                                                    label: "TTC",
                                                    "onUpdate:modelValue": [
                                                      _cache[18] || (_cache[18] = ($event: any) => (_ctx.TTCPrice(_ctx.commission))),
                                                      _cache[19] || (_cache[19] = ($event: any) => ((_ctx.commission.grossAmount) = $event))
                                                    ],
                                                    modelValue: _ctx.commission.grossAmount
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "py-1 pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_select_filled, {
                                                    items: _ctx.vatRates,
                                                    "hide-details": true,
                                                    label: "Taux de TVA",
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (
                                                        _ctx.VATRate(_ctx.commission, $event)
                                                    )),
                                                    "model-value": 
                                                        _ctx.commission.vatType
                                                            ? _ctx.commission.vatRate.toString() +
                                                              _ctx.commission.vatType
                                                            : _ctx.commission.vatRate
                                                    ,
                                                    density: "compact"
                                                  }, null, 8, ["items", "model-value"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { cols: "1" })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "py-2 pt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "2",
                                                class: "d-flex align-center col-auto pr-3 title"
                                              }, {
                                                default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                  _createTextVNode(" Montants supplémentaires ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "9",
                                                class: "d-flex align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_divider)
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex align-center col-auto pl-3 title"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn_add_icon, {
                                                    size: "x-small",
                                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addAdditionalAmount()))
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalAmounts, (additionalAmount, index) => {
                                            return (_openBlock(), _createBlock(_component_v_row, {
                                              "no-gutters": "",
                                              key: index,
                                              class: "pt-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { class: "pr-1" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(additionalAmount.name) + " ", 1),
                                                    _createVNode(_component_v_text_field_filled, {
                                                      "model-value": "additionalAmount.name",
                                                      readonly: true
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, { class: "pr-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      suffix: "€",
                                                      dense: "",
                                                      "single-line": "",
                                                      "hide-details": true,
                                                      modelValue: additionalAmount.amountSigned,
                                                      "onUpdate:modelValue": ($event: any) => ((additionalAmount.amountSigned) = $event)
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, { cols: "1" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.additionalAmounts.length >= 1)
                                                      ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                          key: 0,
                                                          onClick: ($event: any) => (
                                                        _ctx.deleteAdditionalAmount(additionalAmount)
                                                    )
                                                        }, null, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]))
                                      : (_openBlock(), _createBlock(_component_v_row, {
                                          key: 1,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "d-flex justify-center"
                                            }, {
                                              default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                _createTextVNode(" Aucunes données enregistrées ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "d-flex justify-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_btn, {
                                                  size: "small",
                                                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addLine()))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _cache[47] || (_cache[47] = _createTextVNode(" Ajouter une ligne ")),
                                                    _createVNode(_component_v_icon, {
                                                      left: "",
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                        _createTextVNode("$add")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })),
                                    (_ctx.withTransactions)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "py-2 pt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "2",
                                                class: "d-flex align-center col-auto pr-3 title"
                                              }, {
                                                default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                  _createTextVNode(" Encaissement ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "9",
                                                class: "d-flex align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_divider)
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "1",
                                                class: "d-flex align-center col-auto pl-3 title"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn_add_icon, {
                                                    size: "x-small",
                                                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.addTransaction()))
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction, index) => {
                                            return (_openBlock(), _createBlock(_component_v_row, {
                                              "no-gutters": "",
                                              key: index,
                                              class: "pt-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { class: "pr-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_select_filled, {
                                                      modelValue: transaction.name,
                                                      "onUpdate:modelValue": ($event: any) => ((transaction.name) = $event),
                                                      items: _ctx.transactionDefaultAccountableAccounts,
                                                      label: "Type de transaction",
                                                      "item-title": _ctx.getDescription,
                                                      "item-value": "name",
                                                      "hide-details": true,
                                                      density: "compact"
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, { class: "pr-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      label: "Montant",
                                                      suffix: "€",
                                                      dense: "",
                                                      "single-line": "",
                                                      "hide-details": true,
                                                      modelValue: transaction.amount,
                                                      "onUpdate:modelValue": ($event: any) => ((transaction.amount) = $event)
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_col, { cols: "1" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.transactions.length > 1)
                                                      ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.deleteTransaction(transaction))
                                                        }, null, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (_ctx.diff)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "py-2 pt-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 title" }, {
                                                default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                  _createTextVNode(" Ecart ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_divider)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "pt-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { class: "pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    value: "Ecart",
                                                    rounded: "",
                                                    readonly: "",
                                                    "hide-details": "",
                                                    outlined: "",
                                                    density: "compact"
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { class: "pr-1" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_text_field_filled, {
                                                    suffix: "€",
                                                    dense: "",
                                                    "hide-details": true,
                                                    readonly: "",
                                                    modelValue: _ctx.diff,
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.diff) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, { cols: "1" })
                                            ]),
                                            _: 1
                                          })
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (!_ctx.processAnalysis)
                          ? (_openBlock(), _createBlock(_component_v_card_actions, {
                              key: 1,
                              class: "d-flex justify-end mb-10"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.displayDocumentValidationSpeedRun(_ctx.document.status))
                                  ? (_openBlock(), _createBlock(_component_DocumentValidationSpeedRun, {
                                      key: 0,
                                      modelValue: _ctx.lastTicketZValidationDone,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.lastTicketZValidationDone) = $event))
                                    }, null, 8, ["modelValue"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                  class: "mx-1",
                                  disabled: !_ctx.status,
                                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.validPage())),
                                  loading: _ctx.loading,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.validated ? "Validé" : "Valider") + " ", 1),
                                    _withDirectives(_createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                                        _createTextVNode("$check")
                                      ])),
                                      _: 1
                                    }, 512), [
                                      [_vShow, _ctx.validated]
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "loading"]),
                                (_ctx.mode !== 'GeneralLedger')
                                  ? (_openBlock(), _createBlock(_component_v_btn_prev, {
                                      key: 1,
                                      disabled: _ctx.previousDisabled(),
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.previous()))
                                    }, null, 8, ["disabled"]))
                                  : _createCommentVNode("", true),
                                (_ctx.mode !== 'GeneralLedger')
                                  ? (_openBlock(), _createBlock(_component_v_btn_next, {
                                      key: 2,
                                      disabled: _ctx.nextDisabled(),
                                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.next()))
                                    }, null, 8, ["disabled"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.forceForm = true)),
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[51] || (_cache[51] = [
                                  _createTextVNode(" Passer à la validation ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogChooseDownload,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
        title: "Télécharger le document",
        width: "800px"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    rounded: "",
                    block: "",
                    onClick: _cache[31] || (_cache[31] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(true);
                            }),
                    size: "x-large"
                  }, {
                    default: _withCtx(() => _cache[52] || (_cache[52] = [
                      _createTextVNode("Original")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    rounded: "",
                    block: "",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(false);
                            }),
                    size: "x-large"
                  }, {
                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                      _createTextVNode("Marqué")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _cache[54] || (_cache[54] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté). "))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.analyseDocumentDialog,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.analyseDocumentDialog) = $event)),
        title: "Relancer l'analyse du document",
        onValid: _cache[35] || (_cache[35] = ($event: any) => {
                _ctx.analyseDocumentDialog = false;
                _ctx.analyseDocument();
            }),
        "valid-title": "Oui",
        width: "800px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "text-center" }, {
            default: _withCtx(() => _cache[55] || (_cache[55] = [
              _createTextVNode("Êtes-vous sûr(e) de vouloir relancer l'analyse ?")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.deleteZTillDialog,
        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.deleteZTillDialog) = $event)),
        title: "Supprimer le document",
        error: true,
        onValid: _ctx.deleteZTill,
        validTitle: 'Oui je suis sûr(e)',
        width: "800px"
      }, {
        default: _withCtx(() => _cache[56] || (_cache[56] = [
          _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer Z de caisse ?", -1)
        ])),
        _: 1
      }, 8, ["modelValue", "onValid"]),
      (_ctx.inZTillReceipt)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.dialogUploadDocument,
            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.dialogUploadDocument) = $event)),
            title: "Importer un document pour cette OD",
            "max-width": "60vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadDocument, {
                showFirstPrevious: false,
                companyId: _ctx.companyId,
                documentId: 
                    _ctx.inZTillReceipt.originalDocument ? _ctx.inZTillReceipt.originalDocument.id : null
                ,
                documentType: "ZTILL_RECEIPT",
                multiple: false,
                freeTag: false,
                showBtns: true,
                onFile: _cache[37] || (_cache[37] = ($event: any) => (_ctx.linkFile($event)))
              }, null, 8, ["companyId", "documentId"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style"]))
}